export default function IconDownload({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M18.4775 15.6367H22.7959V17.0908H18.4775V20H16.9775V12.7275H18.4775V15.6367ZM15.5225 17.0908H0.977539V15.6367H15.5225V17.0908ZM6.84082 11.2725H5.34082V8.36328H0.977539V6.90918H5.34082V4H6.84082V11.2725ZM22.7959 8.36328H8.25V6.90918H22.7959V8.36328Z"
        fill="currentColor"
      />
    </svg>
  );
}
